import Vue from 'vue';
import VueRouter from 'vue-router';

// import Guard from '@/apps/jobview/services/middleware';
import JobView001 from '@/apps/jobview/001/components/JobView';
//import JobViewExpired from '@/apps/jobview/001/components/JobViewExpired';
import JobViewNotFound from '@/apps/jobview/001/components/JobViewNotFound';
import { getJobViewBaseUrl } from '@/utils/helpers';

Vue.use(VueRouter);

const routes = [{
        path: '/:title/:uuid/:expired',
        name: 'jobview-expired',
        // component: JobViewExpired,
        component: JobView001,
    },
    {
        path: '/not-found',
        name: 'jobview-notfound',
        component: JobViewNotFound,
    },
    {
        path: '/:title/:uuid',
        name: 'jobview',
        component: JobView001,
        beforeEnter: (to, from, next) => {
            next(vm => {vm.lastHost = 'newval';});
        },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: getJobViewBaseUrl(),
    routes,
});

Vue.use(router);

export default router;